const csrftoken = Cookies.get("csrftoken");
const csrfSafeMethod = (method) => {
  return /^(GET|HEAD|OPTIONS|TRACE)$/.test(method);
};
$.ajaxSetup({
  beforeSend: function (xhr, settings) {
    if (!csrfSafeMethod(settings.type) && !this.crossDomain) {
      xhr.setRequestHeader("X-CSRFToken", csrftoken);
    }
  },
});
